import LogoutIcon from "@mui/icons-material/Logout";
import {AppBar, Avatar, Box, Button, Menu, MenuItem, Toolbar, Typography} from "@mui/material";
import React from "react";
import {useAuth} from "react-oidc-context";
import {performLogout} from "../utils/authHelpers";

const Header = () => {
  const auth = useAuth();
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = async () => {
    handleClose();
    await performLogout(auth);
  };

  // Obtener información del usuario
  const userName = auth.user?.profile?.name || auth.user?.profile?.email || "Usuario";
  const userEmail = auth.user?.profile?.email || "";
  const userInitials = userName
    .split(" ")
    .map((n) => n[0])
    .join("")
    .toUpperCase()
    .substring(0, 2);

  return (
    <AppBar position="static">
      <Toolbar>
        <Typography variant="h6" component="div" sx={{flexGrow: 1}}>
          Invoice Parser - AI Analysis
        </Typography>

        <Box sx={{display: "flex", alignItems: "center", gap: 2}}>
          {auth.isAuthenticated && (
            <>
              <Box sx={{display: "flex", alignItems: "center", gap: 1}}>
                <Avatar
                  sx={{
                    bgcolor: "secondary.main",
                    cursor: "pointer",
                    width: 36,
                    height: 36,
                    fontSize: "0.9rem"
                  }}
                  onClick={handleMenu}
                >
                  {userInitials}
                </Avatar>
                <Box sx={{display: {xs: "none", md: "block"}}}>
                  <Typography variant="body2" sx={{fontWeight: 500}}>
                    {userName}
                  </Typography>
                  {userEmail && (
                    <Typography variant="caption" sx={{opacity: 0.8}}>
                      {userEmail}
                    </Typography>
                  )}
                </Box>
              </Box>

              <Menu
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={handleClose}
                anchorOrigin={{
                  vertical: "bottom",
                  horizontal: "right"
                }}
                transformOrigin={{
                  vertical: "top",
                  horizontal: "right"
                }}
              >
                <MenuItem disabled>
                  <Box>
                    <Typography variant="body2" sx={{fontWeight: 500}}>
                      {userName}
                    </Typography>
                    {userEmail && (
                      <Typography variant="caption" color="text.secondary">
                        {userEmail}
                      </Typography>
                    )}
                  </Box>
                </MenuItem>
                <MenuItem onClick={handleLogout}>
                  <LogoutIcon sx={{mr: 1, fontSize: "1.2rem"}} />
                  Cerrar Sesión
                </MenuItem>
              </Menu>

              <Button
                color="inherit"
                startIcon={<LogoutIcon />}
                onClick={handleLogout}
                sx={{display: {xs: "none", sm: "flex"}}}
              >
                Cerrar Sesión
              </Button>
            </>
          )}
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default Header;
